import { ChangeEvent } from 'react'

import {
  CheckboxSwitchControl,
  CheckboxSwitchInput,
  CheckboxSwitchWrapper,
} from '@/lib/core/components/CheckboxSwitch/CheckboxSwitch.styles'

export type CheckboxSwitchProps = {
  name: string
  disabled?: boolean
  checked?: boolean
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

export const CheckboxSwitch = ({ name, ...props }: CheckboxSwitchProps) => (
  <CheckboxSwitchWrapper>
    <CheckboxSwitchInput type="checkbox" name={name} id={name} {...props} />
    <CheckboxSwitchControl htmlFor={name} />
  </CheckboxSwitchWrapper>
)
